import { Vue } from 'vue-property-decorator';
import pluralize from 'pluralize';

Vue.filter('pluralize', (count, word, inclusive, noText = 0) => {
  return pluralize(word, count || noText, inclusive);
});
